export const checkIsAuthCDNUrl = (cdnUrl: string | undefined): boolean => {
    if (!cdnUrl || typeof cdnUrl !== 'string') {
        return false;
    }
    const authCDNDomains = ['statics-test.umu.tw', 'statics.umu.tw', 'statics-test.umu.com', 'statics.umu.com'];
    return authCDNDomains.some((domain) => cdnUrl.includes(domain));
};
